import React from "react";
import { ECSContextProvider } from "./ecsContext";
import ECSMain from "./Main";

export default function ECSTab() {
  return (
    <ECSContextProvider>
      <ECSMain />
    </ECSContextProvider>
  );
}
